export const API_CALL_NOTIFICATION = "api-call";
export const OBJECT_PANEL_WITH_ELABORATION_NOTIFICATION = "ObjectPanelWithElaboration";
export const FETCH_EXTERNAL_CONFIGS = "fetch-external-configs";
export const OBJECT_LIST_NOTIFICATION = "OBJECTS_LIST";
export const INSERT_OBJECT_NOTIFICATION = "insert-coobject";
export const EDIT_OBJECT_NOTIFICATION = "edit-coobject";
export const SAVE_COOBJECT_NOTIFICATION = "saveCoObject";
export const DELETE_OBJECT_NOTIFICATION = "delete-coobject";
export const DELETE_OBJECTS_NOTIFICATION = "delete-coobjects";
export const EDIT_DOCUMENT_PROPERTIES_NOTIFICATION = "saveDocumentProperties";
export const REFRESH_DOCUMENT_PROPERTIES_NOTIFICATION = "saveDocumentProperties";
export const CREATE_DOCUMENT_PART_NOTIFICATION = "createDocumentPart";
export const CREATE_DOCUMENT_NOTIFICATION = "createDocument";
export const FORM_TREE_NOTIFICATION = "fromTreeDocument";
export const AMOUNT_OBJECT_SOURCE = "amountSource";
export const DIMENSION_ATTRIBUTE_OBJECT_SOURCE = "dimensionAttributeSource";
export const CONFIGURATIONS_NOTIFICATION = "configurationsPane";
export const LOGIN_NOTIFICATION = "loginNotification";
export const TABLE_OBJECT_PARAMETERS = "tableObjectParameters";
export const TGK_TEXT_OBJECT_DATASET_FIELDS = "tgkTextObjectDatasetFields";
export const CHANGE_DOC_STRUCTURE_NOTIFICATION = "CHANGE_DOC_STRUCTURE_NOTIFICATION";
export const VALIDATION_NOTIFICATION = "VALIDATION_NOTIFICATION";
export const DUPLICATE_ELABORATION = "DUPLICATE_NOTIFICATION";
export const EXPORT_ELABORATION = "EXPORT_NOTIFICATION";
export const IMPORT_ELABORATION = "IMPORT_NOTIFICATION";
export const DETACH_ELABORATION = "DETACH_NOTIFICATION";
export const CLONE_ELABORATION = "CLONE_NOTIFICATION";
export const RETRIEVE_DOCUMENT_DATA_NOTIFICATION = "RETRIEVE_DOCUMENT_DATA";
export const MISSING_INHERITABLE_PARAMETERS_NOTIFICATION = "MISSING_INHERITABLE_PARAMETERS_NOTIFICATION";
export const SELECT_COOBJECTS_NOTIFICATION = "SELECT_COOBJECTS";
export const PASTE_CONFIGURATION_NOTIFICATION = "PASTE_CONFIGURATION_NOTIFICATION";
export const IXBRL_NOTIFICATION = "IXBRL_NOTIFICATION";
export const DOWNLOAD_NOTIFICATION = "DOWNLOAD_NOTIFICATION";
export const EXPORT_DIFFERENCES_NOTIFICATION = "EXPORT_DIFFERENCES_NOTIFICATION";
export const OBJECTS_LIST_NOTIFICATION = "OBJECTS_LIST";
export const EXPORT_OBJECTS_LIST_NOTIFICATION = "EXPORT_OBJECTS_LIST";
export const INDESIGN_NOTIFICATION = "INDESIGN_NOTIFICATION";
export const IMPORT_DUPLICATE_CONFIGURATION_NOTIFICATION = "IMPORT_DUPLICATE_CONFIGURATION_NOTIFICATION";
export const DB_LIST_NOTIFICATION = "DB_LIST_NOTIFICATION";
export const CHANGE_TEMPLATE_NOTIFICATION = "CHANGE_TEMPLATE_NOTIFICATION";
